import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker'

export default function trackClientEvent(subject: string, action: string, category: string, type: 'interaction' | 'nonInteraction' | 'operational') {
  const evt = {
    context: [],
    event: comluxgroup.createClientEvent_1_0_0({
      subject,
      action,
      type,
      category,
    }),
  }

  trackSelfDescribingEvent(evt)
}
